import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { DeveloperNavigationPath } from "src/common/developers";
import { DeveloperWrapper } from ".";

function Sandbox() {
  const [status, setStatus] = useState("Uninnitialized");

  useEffect(() => {
    startWS();
  }, []);

  function startWS() {
    const host = "ws://127.0.0.1:2420/subscribe_all";
    let socket = new WebSocket(host);
    socket = _socketListener(socket);
    console.log(socket);
  }
  function _socketListener(_socket: WebSocket) {
    _socket.onopen = () => {
      setStatus("OPENED");

    };
    _socket.onmessage = (message_event: MessageEvent) => {
      setStatus(`onmessage: ${JSON.stringify(message_event.data)}`);
    };
    _socket.onclose = () => {

      setStatus("CLOSED");
    };
    _socket.onerror = (error: unknown) => {

      setStatus(`Error: ${JSON.stringify(error)}`);
    };
    return _socket;
  }

  return (
    <DeveloperWrapper type={DeveloperNavigationPath.DefaultNavigation}>
      <Card body>
        <p>Websocket status:</p>
        <p>{status}</p>
      </Card>
    </DeveloperWrapper>
  );
}

export default React.memo(Sandbox);
